module.exports = __webpack_public_path__ + "static/p1-5660f91675d145842658574dc8a20272.png";